<template>
  <div class="ts-w-32 ts-h-32 ts-rounded-md ts-bg-gray-300 ts-p-2 ts-relative">
    <button
        @click.prevent="removeImage"
      class="ts-h-6 ts-w-6 ts-flex ts-items-center ts-justify-center ts-absolute
       ts-right-0 ts-top-0 ts--m-2 ts-z-10 ts-p-1 ts-rounded-full
        ts-bg-gray-500 ts-text-white hover:ts-bg-red-600 ts-duration-200 ts-transition-all"
    >
      <i class="fas fa-times"></i>
    </button>
    <template v-if="isImage">
      <img :src="readFile" alt="" class="ts-w-full ts-h-full" />
    </template>
    <div
      class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
      v-else-if="isPdf"
    >
      <i class="fas fa-file-pdf fa-4x ts-text-red-600"></i>
    </div>
    <div
      class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
      v-else-if="isExcel"
    >
      <i class="fas fa-file-excel fa-4x ts-text-green-300"></i>
    </div>
    <div
      class="ts-flex ts-items-center ts-justify-center ts-w-full ts-h-full"
      v-else
    >
      <i class="far fa-file fa-4x ts-text-yellow-600"></i>
    </div>
    <p
      class="ts-absolute ts-truncate ts-left-0 
        ts-bottom-0 ts-mb-1 ts-font-semibold
         ts-w-full"
    >
      {{ file.name }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'fileView',
  props: ['file', 'value', 'index'],
  data() {
    return {
      model: {}
    }
  },
  computed: {
    isImage() {
      return this.file.type.includes('image')
    },
    isPdf() {
      return this.file.type === 'application/pdf'
    },
    isExcel() {
      return (
        this.file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )
    },
    readFile() {
      if (this.isImage) {
        return URL.createObjectURL(this.file.file)
      }
      return null
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    removeImage() {
      this.model.attached_doc.splice(this.index, 1)
    }
  }
}
</script>
